import React from "react";
import { Box, Typography, Tooltip } from "@mui/material"; // 🟢 added Tooltip here
import packageJson from "../../package.json";
import { useMaterialUIController } from "context";
    
const FooterInfo = () => {
  const [controller] = useMaterialUIController();
  const { miniSidenav } = controller;

  const storedLogin = localStorage.getItem("loginData");
  let loginData = null;

  try {
    loginData = storedLogin ? JSON.parse(storedLogin) : null;
  } catch (err) {
    loginData = null;
  }

  const username = loginData?.username || "";
  const name = `${loginData?.firstName || ""} ${loginData?.lastName || ""}`.trim();

  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        backgroundColor: "#2e7fae", // same blue as sidenav
        py: 1,
        px: miniSidenav ? 1 : 2,
        textAlign: "center",
        transition: "all 0.3s ease-in-out",
        overflow: "hidden",

        // ✨ Animated border line
        "&::before": {
          content: '""',
          position: "absolute",
          top: 0,
          left: "50%",
          transform: "translateX(-50%)",
          width: "100%",
          height: "1px",
          background: "linear-gradient(to right, transparent, rgba(0,0,0,0.4), transparent)",
          transition: "width 0.3s ease-in-out",
          backfaceVisibility: "hidden",
        },
      }}
    >
      {miniSidenav ? (
        <>
          <Tooltip title={name || username} placement="top">
            <Typography
              sx={{
                fontSize: "10px",
                fontWeight: "bold",
                color: "#ffffff",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                maxWidth: "90px", // 🟢 control width so ellipsis works
                mx: "auto",
              }}
            >
              Logged in as:
              <br />
              <strong>{name || username}</strong>
            </Typography>
          </Tooltip>

          <Typography
            sx={{
              fontSize: "12px",
              color: "#ffffff",
              mt: 0.5,
            }}
          >
            Version: {packageJson.version}
          </Typography>
        </>
      ) : (
        <>
          <Tooltip title={name || username} placement="top">
            <Typography
              sx={{
                fontSize: "12px",
                fontWeight: "bold",
                color: "#ffffff",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                maxWidth: "200px", // 🟢 wider when expanded
                mx: "auto",
              }}
            >
              Logged in as: <strong>{name || username}</strong>
            </Typography>
          </Tooltip>

          <Typography
            sx={{
              fontSize: "12px",
              color: "#ffffff",
              mt: 0.5,
            }}
          >
            Version: {packageJson.version}
          </Typography>
        </>
      )}
    </Box>
  );
};

export default FooterInfo;
